import { defineStore } from "pinia";
import axiosInstance from "../config/axios";
import router from "../router";

const ACCESS_TOKEN = "app_access_token";
const REFRESH_TOKEN = "app_refresh_token";

export const useAuthStore = defineStore("auth", {
    state: () => {
        return {};
    },
    actions: {
        registerUser(registerUserData) {
            return axiosInstance.post("/v1/register", registerUserData);
        },

        registerInvitedUser(registerInvitedUserData) {
            return axiosInstance.post("/v1/finish-registration", registerInvitedUserData);
        },
        async loginUser(loginUserData) {
            return axiosInstance.post("/v1/login", loginUserData).then((response) => {
                localStorage.setItem(ACCESS_TOKEN, response.data.access_token);
                localStorage.setItem(REFRESH_TOKEN, response.data.refresh_token);
                return response;
            });
        },
        resetUserVerificationMail(resendVerificationMailData) {
            return axiosInstance.put("/v1/resend-verification-email", resendVerificationMailData).then((response) => {
                router.push({ name: "Login" });
                return response;
            });
        },
        logout() {
            axiosInstance.defaults.headers.common["Authorization"] = undefined;
            localStorage.removeItem(ACCESS_TOKEN);
            localStorage.removeItem(REFRESH_TOKEN);

            if (window.location.pathname === "/") {
                router.push({ name: "Login" });
            } else {
                router.push({ name: "Home" });
            }
        },
        refreshToken(token) {
            return axiosInstance.post("/v1/refresh-token", token).then((response) => {
                localStorage.setItem(ACCESS_TOKEN, response.data.access_token);
                localStorage.setItem(REFRESH_TOKEN, response.data.refresh_token);
                return response;
            });
        },
        resetPassword(data) {
            return axiosInstance.post("/v1/reset-password", data);
        },
        confirmResetPassword(data) {
            return axiosInstance.post("/v1/confirm-reset-password", data);
        },
    },
});
